/*
 * Dependencie for dom-utilities
 */
var $ = require('jquery');
var _ = require('lodash');

/*
 * Main method
 */
 module.exports = {
 	customizeCheckboxes: function($this){
 		if(!$('[data-component-id="RES_GUESTINFOERRORMESSAGE"]').length){
	 		$this.find('input[type="checkbox"]').each(function(){
	 			var label = $('label[for="'+$(this).attr('id')+'"]');
	 			if(label.length && !label.find('.icon-checkmark').length){
	 				label.prepend('<span class="l-userewards-checkmark t-icon-checkmark"></span>');
	 			}
	 		});
 		}
 	},

 	/**
	  * This function is used to fetch the attributes which need to be updated post tile load
	  * @returns {Object} DOM Element on which the module was applied
	  */
	checkValidMDLAttributes: function _checkValidMDLAttributes(requiredAttributes, callback) {
	    var _self = this,
	    postData = {
	    	'attributes': []
	    },
	    attributesObject = _.cloneDeep(window.dataLayer);    
	    Object.keys(requiredAttributes).forEach(function(value) {
	    	if (attributesObject.hasOwnProperty(value) && attributesObject[value] === requiredAttributes[value]) {
	    		postData.attributes.push(value);
	    	}
	    });
	    if (postData.attributes.length) {
	    	callback(postData);
	    }
	   	return true;
	},
	/**
	 * Utility to calcualte the box width of a given element
	 * @param {*} elm 
	 * @returns widh of the element including the left and right margin
	 */
	boxWidth: function _boxWidth(elm) {
		var $elm = $(elm);
		if( $elm.length ) {
		return $elm.width() + parseInt($elm.css('margin-right')) + parseInt($elm.css('margin-left'));
		}
		return 0;
	}
  
 };